import { useQuery } from "@tanstack/react-query";

import { maintenanceStatusQueryOptions } from "./queries";

/**
 * Whether the maintenance window is open, as the server last reported it.
 *
 * The root route resolves the same query during SSR, so the first render on
 * the client matches the server HTML. `false` until an answer arrives: UI that
 * disables itself must not flash disabled for users outside a window.
 */
export function useMaintenanceMode(): boolean {
  const { data } = useQuery(maintenanceStatusQueryOptions());
  return data?.maintenance === true;
}
